module.exports = __webpack_public_path__ + "static/media/21460003-YKS0wSgs.9626be3d.JPG";